const setExpressSession = async () => {
  const userStore = useUserStore();

  try {
    await userStore.expressLogin();
  } catch (error) {
    console.log(error);
  }
};

const setupUserSession = async () => {
  const userStore = useUserStore();
  const { isLoggedIn } = storeToRefs(userStore);

  await userStore.checkIsAuthSession();
  if (!isLoggedIn.value) {
    await setExpressSession();
  }
};

/**
 * Setup user session
 * @param refresh: boolean = false, if true, will refresh session using express login
 */
export const setupPortalSession = async (refresh: boolean = false) => {
  const { isWidgetState, handleWidgetSession } = useWidget();

  if (isWidgetState.value) {
    await handleWidgetSession();
    return;
  }

  if (useNuxtApp()._route?.path?.startsWith('/widget')) {
    return;
  }

  if (refresh) {
    await setExpressSession();
  } else {
    await setupUserSession();
  }
};
